import { render, staticRenderFns } from "./nominations.vue?vue&type=template&id=73f1e806&scoped=true"
import script from "./nominations.vue?vue&type=script&lang=js"
export * from "./nominations.vue?vue&type=script&lang=js"
import style0 from "./nominations.vue?vue&type=style&index=0&id=73f1e806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1e806",
  null
  
)

export default component.exports